import { createDataModuleActions } from '@perpay-web/data-module/createDataModuleActions';

const dataModuleActions = createDataModuleActions('FETCH_TRANSACTION_DETAILS', {
    dataRequest: (pageNumber, pageSize) => ({ pageNumber, pageSize }),
});
export const fetchTransactionDetails = dataModuleActions.dataRequest;
export const replaceTransactionDetails = dataModuleActions.dataSuccess;
export const setTransactionDetailsError = dataModuleActions.dataError;
export const resetTransactionDetails = dataModuleActions.dataReset;
